import React, {Component, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import _, {cloneDeep} from 'lodash';

import LloydCartFactory from '../logic/LloydCartFactory';
import LloydUI from "./LloydUI";
import CartItemFactory from "../logic/CartItemFactory";
import LloydCatalogue from "../models/LloydCatalogue";

// 2026 would you say I had a plethora of properties? do you even know what a plethora is?

// allApps, allClusterStates, allProductSpecs, cartCode, customerVehicle, dynamicCart, group, groupId,
// groupProperties, itemApplications, lloydAttributes, lloydProducts, pageConfig, productAttributes,
// productDetail, productGroup, productLoadStatus, products, renderedBy, shoppingCart, vehicleContext

/**
 *
 * LloydContainer (React Component) - exists within a ProductSection.
 * Invoked by GroupProductsUI component when page type is Lloyd.
 * (note that unlike most containers, this does not connect to React -
 * {GroupProductsApp} does that)
 *
 *
 * This is the top of the lloyd component hierarchy - it manages state
 * and hosts stateless components within.
 * LloydContainer    = section#lloyd-products
 *   form#lloyd-cart-form
 *       LloydMatChooser
 *       LloydOptionsSection
 *       LloydFormBottom
 */
export default function LloydContainer({
  productGroup,
  lloydProducts,
  products,
  lloydAttributes,
  groupProperties,
  customerVehicle,
  vehicleChoices,
}) {

  const [submitting, setSubmitting] = useState(false);

  const lloydCatalogue = useMemo(() => {
    return new LloydCatalogue({
      groupId: productGroup.id,
      lloydProducts, products,
      lloydAttributes, groupProperties
    })
  }, [productGroup?.id, lloydProducts, products, lloydAttributes, groupProperties]);

  const [lloydCart, setLloydCart] = useState(() => {
    let factory = new LloydCartFactory({
      customerVehicle, vehicleChoices, groupProperties, lloydAttributes
    });
    return factory.createCart();
  });

  function updateLloydCart(mutator) {
    // Make a copy first, then modify it. Cannot use immer here because it wants POJOs only
    let newCart = cloneDeep(lloydCart);

    // invoke the function which will probably modify cart
    mutator(newCart);

    setLloydCart(newCart);
    return newCart;
  }

  const callbacks = {
    /**
     * Invoked by LloydMatChooserItem when the user clicks one of the
     * mat pics (or its checkbox), indicating this item should be added
     * to cart or removed from cart. (= in the cart).
     *
     * @param {string} partNumber lloyd-style extended part num like UM19_3079870
     */
    selectItem: (partNumber) => {
      console.log(`LloydContainer: selectItem ${partNumber}`)

      updateLloydCart(cart => {
        const factory = new CartItemFactory({
          lloydProducts, products, cart: lloydCart
        });

        cart.items.toggleItem(partNumber, {factory: factory});
      })
    },

    updateCart: func => { updateLloydCart(func) },

    selectOption: (name, value) => {
      updateLloydCart(cart => cart.setOption(name, value));
    },

    // select option on one item
    selectItemOption: (itemOrPartNumber, name, value) => {
      updateLloydCart(cart => cart.setItemOption(itemOrPartNumber, name, value));
    },

    submit: () => {
      setSubmitting(true);

      let f = document.getElementById('lloyd-cart-form');
      f.submit();
    }
  };

  //  pageConfig, allProductSpecs, cartCode, productGroup, shoppingCart, dynamicCart, customerVehicle,
  // vehicleContext, allClusterStates, renderedBy, group, productAttributes, productDetail, itemApplications,
  // allApps, productLoadStatus

  window.LLOYD_STATE = {lloydCatalogue, lloydCart}

  if (!productGroup) return null;

  return <LloydUI
    callbacks={callbacks}
    lloydCart={lloydCart}
    lloyd={lloydCatalogue}
    submitting={submitting}
  />
}

LloydContainer.propTypes = {
  // groupId, groupProperties, clusterStates, customerVehicle,
  // itemsUrl, clusterIndex, itemApplications, products,
  // lloydProducts, lloydAttributes, dispatch
  lloydProducts: PropTypes.object.isRequired,
  lloydAttributes: PropTypes.object.isRequired
}
